import { Byte } from "./Byte";
import { WordText } from "./WordText";
export class JsonBin {
    static isJsonBin(data) {
        if (data.byteLength < 5)
            return false;
        const value = (new Uint32Array(data, 0, 4))[0];
        return value === ISJSONBIN || value === ISJSONBIN2 || value === ISJSONBIN3;
    }
    static parse(data, createObjWithClass) {
        if (!JsonBin.isJsonBin(data)) {
            let b = new Byte();
            b.writeArrayBuffer(data);
            b.pos = 0;
            let str = b.readUTFBytes();
            return JSON.parse(str);
        }
        _createObjWithClass = createObjWithClass;
        let bData = new Byte();
        let strMap;
        let binMark;
        bData.writeArrayBuffer(data);
        bData.pos = 0;
        _objectRef = {};
        binMark = bData.readInt32();
        switch (binMark) {
            case ISJSONBIN:
                strMap = bData.readUTFString();
                break;
            case ISJSONBIN2:
            case ISJSONBIN3:
                strMap = bData.readUTFString32();
                break;
            default:
                bData.pos = 0;
                return null;
        }
        var keyMap = {
            keys: {},
            strs: ["BEGIN", 0],
            keyArray: [],
            keyIndex: 1
        };
        keyMap.strs = strMap.split(SPLITCHAR);
        keyMap.keyArray.length = keyMap.strs.length / 2;
        for (var i = 0, n = keyMap.strs.length; i < n; i += 2) {
            keyMap.keyArray[i / 2] = [keyMap.strs[i], parseInt(keyMap.strs[i + 1])];
        }
        _dataStartOfs = bData.pos;
        var r = {};
        readOne(r, bData, null, OBJECT, keyMap);
        return binMark == ISJSONBIN3 ? r.top : r;
    }
    static write(o, enableClass) {
        _deep = 0;
        _classEnable_ = enableClass;
        var keyMap = {
            keys: {},
            strs: ["BEGIN", 0],
            keyArray: [],
            keyIndex: 1
        };
        _objectRef = {};
        var out = new Byte();
        writeObject(out, keyMap, { top: o });
        out.writeUint16(OBJECTEND);
        var r = new Byte();
        r.writeInt32(ISJSONBIN3);
        r.writeUTFString32(keyMap.strs.join(SPLITCHAR));
        r.writeArrayBuffer(out.buffer);
        return r.buffer;
    }
}
export class JsonBinRead {
    static get instance() {
        return JsonBinRead._instance || (JsonBinRead._instance = new JsonBinRead());
    }
    static IsJsonbin(data) {
        return JsonBin.isJsonBin(data);
    }
    static parse(value) {
        return JsonBin.parse(value);
    }
    read(data, createObjWithClass) {
        return JsonBin.parse(data, createObjWithClass);
    }
}
export class JsonBinWrite {
    static get instance() {
        return JsonBinWrite._instance || (JsonBinWrite._instance = new JsonBinWrite());
    }
    write(o, enableClass) {
        return JsonBin.write(o, enableClass);
    }
}
const ISJSONBIN = 0xFFFFFF;
const ISJSONBIN2 = 0xFFFFFE;
const ISJSONBIN3 = 0xFFFFFD;
const SPLITCHAR = String.fromCharCode(3);
const COMPRESS_NEW = 1;
const COMPRESS_REF = 2;
const COMPRESS_REFMODIFY = 3;
const NUM8 = 0;
const NUM16 = 1;
const NUM32 = 2;
const BOOLEAN = 3;
const DOUBLE = 4;
const STRING = 5;
const ARRAY8 = 6;
const ARRAY16 = 7;
const ARRAYEMPTY = 8;
const ARRAYNUM8 = 9;
const ARRAYNUM16 = 10;
const ARRAYNUM32 = 11;
const ARRAYDOUBLE = 12;
const ARRAYSTRING = 13;
const NULL = 14;
const OBJECT = 15;
const NUM16_1000 = 16;
const NUM32_1000 = 17;
const WORDTEXT = 18;
const ARRAYBUFFER = 19;
const ARRAYREF = 20;
const ARRAYREFSOURCE8 = 21;
const ARRAYREFSOURCE16 = 22;
const ARRAYBUFFER32 = 23;
const ARRAYREF32 = 24;
const ARRAY32 = 25;
const OBJECTTHISCLASS = 26;
const NUM64 = 27;
const INT8ARRAY = 28;
const UINT8ARRAY = 29;
const INT16ARRAY = 30;
const FLOAT32ARRAY = 31;
const OBJECTEND = 0x7FFF;
var _objectRef;
var _dataStartOfs;
var _createObjWithClass;
function readArray(data, pos, n, type, keyMap) {
    var array = [];
    array.length = n;
    var endPos;
    if (pos >= 0) {
        endPos = data.pos;
        data.pos = pos;
    }
    for (var i = 0; i < n; i++) {
        array[i] = readOne({}, data, null, data.readUint8(), keyMap);
    }
    if (pos >= 0) {
        data.pos = endPos;
    }
    return array;
}
function getLen(data) {
    let n = data.readUint8();
    return (n & 0x80) === 0 ? n : (data.readUint8() | ((n & ~0x80) << 8));
}
function readOne(parent, data, key, type, keyMap) {
    let n, value;
    switch (type) {
        case NULL:
            value = null;
            break;
        case NUM8:
            value = data.readByte();
            break;
        case NUM16:
            value = data.readInt16();
            break;
        case NUM32:
            value = data.readInt32();
            break;
        case NUM64:
            value = toLargeNumber(data.readInt32(), data.readInt32());
            break;
        case BOOLEAN:
            value = data.readByte() ? true : false;
            break;
        case DOUBLE:
            value = data.readFloat32();
            break;
        case NUM16_1000:
            value = data.readInt16() / 1000;
            break;
        case NUM32_1000:
            value = data.readInt32() / 1000;
            break;
        case STRING:
            value = keyMap.keyArray[data.readUint16()][0];
            break;
        case WORDTEXT:
            n = data.readUint16();
            value = keyMap.keyArray[n][3];
            if (!value) {
                value = keyMap.keyArray[n][3] = new WordText();
                value.setText(keyMap.keyArray[n][0]);
            }
            break;
        case ARRAYEMPTY:
            data.readUint8();
            value = [];
            break;
        case ARRAYNUM8:
            value = [];
            value.length = n = data.readUint8();
            for (let i = 0; i < n; i++)
                value[i] = data.readByte();
            break;
        case ARRAYNUM16:
            value = [];
            value.length = n = data.readUint8();
            for (let i = 0; i < n; i++)
                value[i] = data.readInt16();
            break;
        case ARRAYNUM32:
            value = [];
            value.length = n = data.readUint8();
            for (let i = 0; i < n; i++)
                value[i] = data.readInt32();
            break;
        case ARRAYDOUBLE:
            value = [];
            value.length = n = data.readUint8();
            for (let i = 0; i < n; i++)
                value[i] = data.readFloat32();
            break;
        case ARRAYBUFFER:
            value = data.readArrayBuffer(data.readUint16());
            break;
        case ARRAYBUFFER32:
            value = data.readArrayBuffer(data.readUint32());
            break;
        case INT8ARRAY:
            n = getLen(data);
            value = data.readInt8Array(data.pos, n);
            break;
        case UINT8ARRAY:
            n = getLen(data);
            value = data.readUint8Array(data.pos, n);
            break;
        case INT16ARRAY:
            n = getLen(data);
            value = data.readInt16Array(data.pos, n);
            break;
        case FLOAT32ARRAY:
            n = getLen(data);
            value = data.readFloat32Array(data.pos, n);
            break;
        default:
            return readOne_other(parent, data, key, type, keyMap);
    }
    parent && key && (parent[key] = value);
    return value;
}
function readOne_other(parent, data, key, type, keyMap) {
    let cur = parent;
    let value;
    let n, i;
    let pos;
    switch (type) {
        case ARRAY8:
        case ARRAY16:
        case ARRAY32:
            switch (type) {
                case ARRAY8:
                    n = data.readUint8();
                    break;
                case ARRAY16:
                    n = data.readInt16();
                    break;
                case ARRAY32:
                    n = data.readUint32();
                    break;
            }
            var array = value = [];
            array.length = n;
            for (i = 0; i < n; i++) {
                type = data.readUint8();
                array[i] = readOne(null, data, null, type, keyMap);
            }
            break;
        case ARRAYREFSOURCE8:
        case ARRAYREFSOURCE16:
            n = type === ARRAYREFSOURCE8 ? data.readUint8() : data.readInt16();
            pos = data.pos - _dataStartOfs;
            value = readArray(data, -1, n, type, keyMap);
            _objectRef[pos] = { array: value, pos: pos };
            break;
        case ARRAYREF:
        case ARRAYREF32:
            i = data.readByte();
            pos = type === ARRAYREF ? data.readUint16() : data.readUint32();
            let objectRef = _objectRef[pos];
            if (!objectRef) {
                throw new Error("load ref err");
                return null;
            }
            if (i === COMPRESS_NEW) {
                value = readArray(data, pos + _dataStartOfs, objectRef.array.length, type, keyMap);
            }
            else
                value = objectRef.array;
            break;
        case OBJECT:
        case OBJECTTHISCLASS:
            if (key != null || !parent) {
                if (type === OBJECT) {
                    cur = {};
                }
                else {
                    n = data.readUint16();
                    cur = _createObjWithClass(keyMap.keyArray[n][0]);
                    if (!cur)
                        throw new Error("jsonbin read err,no this class:" + keyMap.keyArray[n][0]);
                }
                key && parent && (parent[key] = cur);
            }
            let keyDef;
            while (true) {
                n = data.readUint16();
                if (n === OBJECTEND)
                    break;
                keyDef = keyMap.keyArray[n];
                readOne(cur, data, keyDef[0], keyDef[1], keyMap);
            }
            value = cur;
            cur = parent;
            break;
    }
    (key != null) && (cur[key] = value);
    return value;
}
function toLargeNumber(n1, n2) {
    let n2str = n2.toString(16);
    if (n2str.length < 7) {
        for (let i = n2str.length; i < 7; i++)
            n2str = "0" + n2str;
    }
    return parseInt(n1.toString(16) + "" + n2str, 16);
}
const COMPRESS = "_$TeMpkEy$_CoMpReSs";
const NOSAVEKEY = "_$TeMpkEyNoSv$_";
const NOSAVETHISOBJ = "$__$disbaleJsonBinSv";
const NOSAVE_KEY_LEN = 15;
const NOSAVETHISOBJ_DELETE = 2;
const NOSAVETHISOBJ_TRUE = 1;
var _objectRef = {};
var _classEnable_;
var _deep = 0;
function saveKey(key, valueType, keyMap, out) {
    _deep++;
    var keysv = key + "/&&__*?/" + valueType;
    var keyNum = has(keyMap.keys, keysv) ? keyMap.keys[keysv] : undefined;
    if (!keyNum) {
        keyNum = keyMap.keys[keysv] = keyMap.keyIndex;
        keyMap.strs.push(key, valueType);
        keyMap.keyIndex++;
    }
    out.writeUint16(keyNum);
    _deep--;
}
function getValueArrayType(value) {
    switch (typeof (value)) {
        case "number":
            if (Math.floor(value) !== value)
                return ARRAYDOUBLE;
            var valueabs = Math.abs(value);
            if (valueabs < 128)
                return ARRAYNUM8;
            if (valueabs < 0x7FFF)
                return ARRAYNUM16;
            return ARRAYNUM32;
        case "string":
            return OBJECT;
        case "boolean":
            return BOOLEAN;
    }
    return OBJECT;
}
function writeStrOrWordText(keyMap, key, value, out, isWordText) {
    var type = isWordText ? WORDTEXT : STRING;
    (key != null) ? (saveKey(key, type, keyMap, out)) : (out.writeUint8(type));
    var keyNum = has(keyMap.keys, value) ? keyMap.keys[value] : undefined;
    if (keyNum === undefined) {
        keyNum = keyMap.keyIndex;
        keyMap.keys[value] = keyNum;
        keyMap.strs.push(value, 0);
        keyMap.keyIndex++;
    }
    out.writeUint16(keyNum);
}
function writeString(keyMap, value, out) {
    var keyNum = has(keyMap.keys, value) ? keyMap.keys[value] : undefined;
    if (keyNum === undefined) {
        keyNum = keyMap.keyIndex;
        keyMap.keys[value] = keyNum;
        keyMap.strs.push(value, 0);
        keyMap.keyIndex++;
    }
    out.writeUint16(keyNum);
}
function getObjectTypeof(value) {
    if (value instanceof ArrayBuffer)
        return "ArrayBuffer";
    if (value instanceof Uint8Array)
        return "Uint8Array";
    if (value instanceof Int8Array)
        return "Int8Array";
    if (value instanceof Int16Array)
        return "Int16Array";
    if (value instanceof Float32Array)
        return "Float32Array";
    if ((value instanceof WordText) || isWordText(value))
        return "WordText";
    return "object";
}
function isWordText(o) {
    return o && o._text && (o._$_$ISWORDTYEXT || o.lastGCCnt != null);
}
function writeLen(out, len) {
    if (len < 0x80)
        out.writeUint8(len);
    else if (len < 0x8000) {
        out.writeUint8((len >> 8) | 0x80);
        out.writeUint8(len & 0xFF);
    }
    else
        throw new Error("jsonbin save len must<0x8000" + " " + len);
}
function writeBigNumber(out, value) {
    let numstr = value.toString(16);
    let n1 = parseInt(numstr.substring(0, numstr.length - 7), 16);
    let n2 = parseInt(numstr.substring(numstr.length - 7), 16);
    out.writeInt32(n1);
    out.writeInt32(n2);
    if (toLargeNumber(n1, n2) != value)
        throw new Error("save big number err:" + value);
}
function writeOne(out, keyMap, key, value, parent) {
    if (value == undefined) {
        return false;
    }
    let type = typeof (value);
    if (type === "object" && value) {
        if (value.$__$disbaleJsonBinSv) {
            if (value.$__$disbaleJsonBinSv === NOSAVETHISOBJ_DELETE) {
            }
            return false;
        }
        type = getObjectTypeof(value);
    }
    switch (type) {
        case "number":
            if (Math.floor(value) !== value) {
                var value1000 = value * 1000;
                if ((value1000 | 0) === value1000) {
                    if (Math.abs(value) < 32) {
                        (key != null) ? saveKey(key, NUM16_1000, keyMap, out) : out.writeUint8(NUM16_1000);
                        out.writeInt16(value1000);
                        return true;
                    }
                    if (Math.abs(value) < 2147483) {
                        (key != null) ? saveKey(key, NUM32_1000, keyMap, out) : out.writeUint8(NUM32_1000);
                        out.writeInt32(value1000);
                        return true;
                    }
                }
                (key != null) ? saveKey(key, DOUBLE, keyMap, out) : out.writeUint8(DOUBLE);
                out.writeFloat32(value);
                return true;
            }
            var valueabs = Math.abs(value);
            if (valueabs < 128) {
                (key != null) ? saveKey(key, NUM8, keyMap, out) : out.writeUint8(NUM8);
                out.writeByte(value);
                return true;
            }
            if (valueabs < 0x7FFF) {
                (key != null) ? saveKey(key, NUM16, keyMap, out) : out.writeUint8(NUM16);
                out.writeInt16(value);
                return true;
            }
            if (valueabs < 0x7FFFFFFF) {
                (key != null) ? saveKey(key, NUM32, keyMap, out) : out.writeUint8(NUM32);
                out.writeInt32(value);
                return true;
            }
            (key != null) ? saveKey(key, NUM64, keyMap, out) : out.writeUint8(NUM64);
            writeBigNumber(out, value);
            return true;
        case "string":
            writeStrOrWordText(keyMap, key, value, out, false);
            return true;
        case "boolean":
            (key != null) ? saveKey(key, BOOLEAN, keyMap, out) : out.writeUint8(BOOLEAN);
            out.writeByte(value ? 1 : 0);
            return true;
        case 'ArrayBuffer':
            (key != null) ? saveKey(key, ARRAYBUFFER32, keyMap, out) : out.writeUint8(ARRAYBUFFER32);
            out.writeUint32(value.byteLength);
            out.writeArrayBuffer(value);
            return true;
        case 'Uint8Array':
            (key != null) ? saveKey(key, UINT8ARRAY, keyMap, out) : out.writeUint8(UINT8ARRAY);
            writeLen(out, value.length);
            out.writeArrayBuffer(value.buffer);
            return true;
        case 'Int8Array':
            (key != null) ? saveKey(key, INT8ARRAY, keyMap, out) : out.writeUint8(INT8ARRAY);
            writeLen(out, value.length);
            out.writeArrayBuffer(value.buffer);
            return true;
        case 'Int16Array':
            (key != null) ? saveKey(key, INT16ARRAY, keyMap, out) : out.writeUint8(INT16ARRAY);
            writeLen(out, value.length);
            out.writeArrayBuffer(value.buffer);
            return true;
        case 'Float32Array':
            (key != null) ? saveKey(key, FLOAT32ARRAY, keyMap, out) : out.writeUint8(FLOAT32ARRAY);
            writeLen(out, value.length);
            out.writeArrayBuffer(value.buffer);
            return true;
        case 'WordText':
            writeStrOrWordText(keyMap, key, value._text, out, true);
            return true;
        case "object":
            break;
        default:
            throw new Error("jsonbin no this type:" + type);
    }
    if (!value) {
        (key != null) ? saveKey(key, NULL, keyMap, out) : out.writeUint8(NULL);
        return true;
    }
    if (!(value instanceof Array)) {
        if (_classEnable_ && value.__CLASS__) {
            (key != null) ? saveKey(key, OBJECTTHISCLASS, keyMap, out) : out.writeUint8(OBJECTTHISCLASS);
        }
        else
            (key != null) ? saveKey(key, OBJECT, keyMap, out) : out.writeUint8(OBJECT);
        writeObject(out, keyMap, value);
        out.writeUint16(OBJECTEND);
        return true;
    }
    return saveArray(parent, out, keyMap, key, value);
}
function saveArray(parent, out, keyMap, key, value) {
    var j, n = value.length;
    if (n === 0) {
        (key != null) ? saveKey(key, ARRAYEMPTY, keyMap, out) : out.writeUint8(ARRAYEMPTY);
        out.writeByte(0);
        return true;
    }
    var startType;
    if (n > 1 && n < 250 && ((startType = getValueArrayType(value[0])) != OBJECT)) {
        for (j = 1; j < n; j++) {
            if (startType !== getValueArrayType(value[j])) {
                startType = OBJECT;
                break;
            }
        }
        if (startType != OBJECT && startType != BOOLEAN) {
            (key != null) ? saveKey(key, startType, keyMap, out) : out.writeUint8(startType);
            out.writeUint8(value.length);
            switch (startType) {
                case ARRAYNUM8:
                    for (j = 0; j < n; j++)
                        out.writeByte(value[j]);
                    break;
                case ARRAYNUM16:
                    for (j = 0; j < n; j++)
                        out.writeInt16(value[j]);
                    break;
                case ARRAYNUM32:
                    for (j = 0; j < n; j++)
                        out.writeInt32(value[j]);
                    break;
                case ARRAYDOUBLE:
                    for (j = 0; j < n; j++)
                        out.writeFloat32(value[j]);
                    break;
            }
            return true;
        }
    }
    var typeArray;
    if (n < 250) {
        typeArray = ARRAY8;
    }
    else if (n < 32700) {
        typeArray = ARRAY16;
    }
    else {
        typeArray = ARRAY32;
    }
    var posHead = out.pos;
    (key != null) ? saveKey(key, typeArray, keyMap, out) : out.writeUint8(typeArray);
    var pos = out.pos, s = 0;
    switch (typeArray) {
        case ARRAY8:
            out.writeUint8(n);
            break;
        case ARRAY16:
            out.writeInt16(n);
            break;
        case ARRAY32:
            out.writeUint32(n);
            break;
    }
    var posData = out.pos;
    for (j = 0; j < n; j++) {
        if (writeOne(out, keyMap, null, value[j], parent))
            s++;
    }
    if (s != n) {
        var tmp = out.pos;
        out.pos = pos;
        typeArray === ARRAY8 ? out.writeUint8(s) : out.writeInt16(s);
        out.pos = tmp;
    }
    var compress;
    if (key && parent && (compress = parent[COMPRESS + key])) {
        useCompress(out, keyMap, key, value, posHead, posData, compress, typeArray);
    }
    return true;
}
function useCompress(out, keyMap, key, value, posHead, dataPos, compress, typeArray) {
    var dLen = out.pos - dataPos;
    if (dLen < 64) {
    }
    var hashCode = getHash(out._u8d_, dataPos, dLen);
    var same;
    var src;
    var i, n;
    if (_objectRef[hashCode]) {
        var datas = _objectRef[hashCode];
        n = datas.length;
        for (i = 0; i < n; i++) {
            src = datas[i];
            if (src.value == value) {
                same = src;
                break;
            }
        }
        if (!same) {
            for (i = 0; i < n; i++) {
                src = datas[i];
                if (isSame(out._u8d_, src.pos, src.len, out._u8d_, dataPos, dLen)) {
                    same = src;
                    break;
                }
            }
        }
    }
    else
        _objectRef[hashCode] = [];
    if (!same) {
        _objectRef[hashCode].push({ hashCode: hashCode, pos: dataPos, len: dLen, value: value });
        out.pos = posHead;
        saveKey(key, typeArray === ARRAY8 ? ARRAYREFSOURCE8 : ARRAYREFSOURCE16, keyMap, out);
        out.pos = dataPos + dLen;
    }
    else {
        out.pos = posHead;
        saveKey(key, ARRAYREF32, keyMap, out);
        out.writeByte(compress);
        out.writeUint32(same.pos);
    }
}
function writeObject(out, keyMap, o) {
    _classEnable_ && o.__CLASS__ && writeString(keyMap, o.__CLASS__, out);
    for (var key in o) {
        if (key && key.length > NOSAVE_KEY_LEN && key.substr(0, NOSAVE_KEY_LEN) == NOSAVEKEY) {
            continue;
        }
        (_classEnable_ && key == "__CLASS__") || writeOne(out, keyMap, key, o[key], o);
    }
}
function getHash(buffer, start, len, magic = 9191891) {
    var i;
    var rst = 0;
    for (i = 0; i < len; i++) {
        rst = (rst * 2 + buffer[start + i]) % magic;
    }
    return rst;
}
function isSame(buffer1, start1, len1, buffer2, start2, len2) {
    if (len1 != len2)
        return false;
    var i, len;
    len = len1;
    for (i = 0; i < len; i++) {
        if (buffer1[start1 + i] != buffer2[start2 + i])
            return false;
    }
    return true;
}
const hasOwnProp = Object.prototype.hasOwnProperty;
function has(obj, key) {
    return hasOwnProp.call(obj, key);
}
